// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".v-list-item-group .v-list-item--active{color:inherit}", "",{"version":3,"sources":["/Users/kumakuraharuka/gitserver/motion-gallery/faq/node_modules/vuetify/src/components/VList/VListItemGroup.sass"],"names":[],"mappings":"AAGE,wCACE,aAAA","file":"VListItemGroup.sass","sourcesContent":["@import '../../styles/styles.sass'\n\n.v-list-item-group\n  .v-list-item--active\n    color: inherit\n"]}]);
// Exports
module.exports = exports;
